import React from 'react'
import { Spinner, Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import MessageFeed from 'src/apps/Messages/components/Feed'
import { useInitiative } from 'src/graphql/hooks'
import { InitiativeHierarchyProvider } from 'src/libraries/contexts/InitiativeHierarchy'
import PeopleBlock from './PeopleBlock'

const Group = () => {
   const { initiativeSlug } = useParams()
   const { initiative, networkStatus, refetch } = useInitiative({
      slug: initiativeSlug
   })

   const initialLoading = networkStatus <= 2
   if (initialLoading) {
      return (
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            textAlign="center"
            padding="90px"
            backgroundColor="#fff"
            borderRadius="6px">
            <Spinner color="#ccc" width="24px" height="24px" />
         </View>
      )
   }

   return (
      <InitiativeHierarchyProvider
         initiative={initiative}
         refetchInitiative={refetch}>
         <View
            position="relative"
            width="100%"
            height="100%"
            borderRadius="4px"
            style={{ overflow: 'hidden' }}>
            <View
               position="absolute"
               top="0px"
               width="320px"
               left="0px"
               bottom="0px"
               padding="0px 20px[a-d] 0px 20px[e-f]"
               borderLeft="1px solid #222"
               scroll="on">
               <View
                  display="flex"
                  alignItems="center"
                  width="100%"
                  height="90px"
                  paddingBottom="10px[e] 20px[f]"
                  borderBottom="1px solid rgba(255,255,255,0.15)">
                  <Text color="#fff" size="6" letterSpacing="-0.5px">
                     {initiative.name}
                  </Text>
               </View>
            </View>
            <View
               display="flex"
               position="absolute"
               top="0px"
               left="320px"
               right="0px"
               bottom="0px"
               padding="40px"
               backgroundColor="#fff"
               borderLeft="1px solid rgba(255,255,255,0.05)"
               borderRadius="4px"
               scroll="on">
               <View width="calc(100% - 250px)">
                  <MessageFeed
                     currentUserCanModerate={initiative.currentUserCanModerate}
                     displayMode="feed"
                     hasUnreadEntries={initiative.thread.hasUnreadEntries}
                     messageLastViewed={initiative.thread.messageLastViewed}
                  />
               </View>
               <View width="250px" paddingLeft="30px">
                  <PeopleBlock />
               </View>
            </View>
         </View>
      </InitiativeHierarchyProvider>
   )
}

export default Group
